"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Tag224Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "tag-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { id: "Group-5", transform: "translate(12.861723, 10.537849) rotate(45.000000) translate(-12.861723, -10.537849) translate(6.861723, 0.037849)", fill: "#000000", fillRule: "nonzero" },
                react_1.default.createElement("path", { d: "M2,6.93677899 L2,18.576416 L10,18.576416 L10,6.92931449 L6.02935338,3.57914745 L2,6.93677899 Z M6.03735352,0.969116211 L11.8224318,5.85017975 C11.9350297,5.94518241 12,6.0850065 12,6.23232862 L12,20.076416 C12,20.3525584 11.7761424,20.576416 11.5,20.576416 L0.5,20.576416 C0.223857625,20.576416 7.76601006e-14,20.3525584 7.76601006e-14,20.076416 L7.76601006e-14,6.23419475 C7.76601006e-14,6.08580065 0.0659151979,5.94507333 0.179916967,5.85007647 L6.03735352,0.969116211 Z M6,6 C5.44771525,6 5,6.44771525 5,7 C5,7.55228475 5.44771525,8 6,8 C6.55228475,8 7,7.55228475 7,7 C7,6.44771525 6.55228475,6 6,6 Z", id: "Combined-Shape" }))));
}
function Tag224(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Tag224Svg, Object.assign({}, svgProps)));
}
exports.default = Tag224;
//# sourceMappingURL=Tag224.js.map